"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRestate = void 0;
const React = require("react");
const store_context_1 = require("./store-context");
const utils_1 = require("./utils");
function withRestate(Component) {
    let isSelectorBeenUsed;
    return React.memo((props) => {
        const { getScope, subscribe } = React.useContext(store_context_1.RestateContext);
        const getActions = React.useCallback((scopeName) => getScope(scopeName).actions, [getScope]);
        const getSelectors = React.useCallback((scopeName) => {
            isSelectorBeenUsed = true;
            const scope = getScope(scopeName);
            return scope.model.selectors;
        }, [getScope]);
        const forceUpdate = (0, utils_1.useForceUpdate)();
        const changeHandler = React.useCallback(() => {
            if (isSelectorBeenUsed === true) {
                forceUpdate();
            }
        }, [forceUpdate]);
        React.useEffect(() => subscribe(changeHandler), [subscribe]);
        return (React.createElement(Component, { ...props, getActions: getActions, getSelectors: getSelectors }));
    });
}
exports.withRestate = withRestate;
//# sourceMappingURL=with-restate.js.map